import { isRecord } from '../types.util';

const WHATSAPP_SEND_RECOVERY_CODES = new Set([
  'WhatsAppAccountVerificationRequired',
  'WhatsAppAccountReconnectRequired',
]);

const findRecoveryCode = (
  value: unknown,
  remainingDepth: number
): string | null => {
  if (!isRecord(value)) return null;
  if (
    typeof value.recoveryCode === 'string' &&
    WHATSAPP_SEND_RECOVERY_CODES.has(value.recoveryCode)
  ) {
    return value.recoveryCode;
  }
  return remainingDepth > 0
    ? findRecoveryCode(value.details, remainingDepth - 1)
    : null;
};

/**
 * Maps allowlisted WhatsApp recovery codes carried by the gateway envelope.
 * Provider/internal prose is never shown to the user.
 * @param error - Unknown client failure, usually a generated ApiError.
 * @param fallback - Localized generic send error.
 * @param recoveryMessage - Localized connection recovery guidance.
 * @returns Localized recovery guidance for a known code, or the fallback.
 */
export const getWhatsAppSendErrorMessage = (
  error: unknown,
  fallback: string,
  recoveryMessage = fallback
): string => {
  if (!isRecord(error) || !isRecord(error.body)) return fallback;
  const body = error.body;
  const external =
    isRecord(body.details) && isRecord(body.details.externalError)
      ? body.details.externalError
      : body;
  return (external.code === 409 || external.code === 422) &&
    findRecoveryCode(external, 4)
    ? recoveryMessage
    : fallback;
};
